/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import PageView from './PageView';
import CommentForm from '../../shared-components/comments/CommentForm';
import ReplyForm from '../../shared-components/comments/ReplyForm';

const PreTrialCommentsConfig = {
  routes: [
    {
      path: 'pre-trial-comments/pages/:id',
      element: <PageView />,
      children: [
        {
          path: 'comments/:commentId/edit',
          element: <CommentForm collection="pre_trial_comments" />
        },
        {
          path: 'comments/:commentId/reply/:replyId/edit',
          element: <ReplyForm collection="pre_trial_comments" />
        }
      ]
    }
  ]
};

export default PreTrialCommentsConfig;
